import Http from '@/services/http';
import { InstallationRegionalResponse, InstallationRegionalRequest } from 'sigma-mappings';

const urls = {
  getRegional: '/usuario/empresas/regionais', // -  Além do lookup trás a informação da empresa que pertence.
};

export default {
  /**
   * Recupera uma lista de regionais que o usuário tem acesso
   * @param {[]} companyIds Lista de ids de empresas para filtro
   * @returns {Promise<*>} Lista de regionais
   */
  getRegional(companyIds) {
    const http = new Http();
    let params = { };
    if (companyIds) {
      params = new InstallationRegionalRequest({
        companyIds,
      });
    }
    return http
      .post(urls.getRegional, params)
      .then(({ data }) => data.map(item => new InstallationRegionalResponse(item)));
  },
};
